import { createContentfulImageLoader } from './create-contentful-image-loader.esm.js';

const CONTENTFUL_CDN_HOST = 'images.ctfassets.net';
const getImageLoader = ({ src, unoptimized, resize })=>{
    if (typeof src !== 'string') {
        return undefined;
    }
    const isContentfulImage = src.includes(CONTENTFUL_CDN_HOST);
    const isSvgImage = src.includes('.svg');
    if (unoptimized || !isContentfulImage || isSvgImage) {
        /**
         * Return undefined when the image is not hosted on Contentful or is an SVG
         * image or when the image is set to unoptimized.
         */ return undefined;
    }
    return createContentfulImageLoader(resize);
};

export { getImageLoader };
